export default __webpack_public_path__ + "assets/f9ef7ded6bf1f4f442bdc59116fff79e.jpeg";